import { render, staticRenderFns } from "./SalesNoteConfiguration.vue?vue&type=template&id=6273c438&scoped=true&"
import script from "./SalesNoteConfiguration.vue?vue&type=script&lang=js&"
export * from "./SalesNoteConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./SalesNoteConfiguration.vue?vue&type=style&index=0&id=6273c438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6273c438",
  null
  
)

export default component.exports